<template>
    <div>
        <h2>
            {{ title }}  
            <el-tooltip class="item" effect="dark" content="注:发送顺序是从上到下,请注意上传图片顺序" placement="top-start">
            <i class="el-icon-warning-outline"></i>
            </el-tooltip>
        </h2>
        <br/>
        <el-form label-width="80px" :model="obj"  ref="ruleForm">
            <el-form-item label="是否开启：">
            <el-switch v-model="obj.isTrue" active-text="开启"></el-switch>  
            </el-form-item>
            <el-form-item 
            :label="item.labelName+'：'"  
            :prop="'list.'+index+'.content'" v-for="(item, index) in obj.list" 
            :key="index" 
            :inline-message="true" >
              <!-- <el-button style="float:right">删除</el-button> -->
                <el-col :span="20">
                 <el-input v-model="item.content" type="textarea" v-if="item.messageType==1"></el-input>
                 <el-upload  
                 v-if="item.messageType==2"
                 :action="uploadUrl()"
                 list-type="picture-card"
                 :multiple="true"
                 :on-success="(response,file,fileList)=>uploadSuccess(response,file,fileList,index)"
                 :file-list="item.content"
                 :before-upload="(fileList)=>beftoreUpload(fileList,item.messageType)"
                 accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF"
                 :auto-upload="true">
                     <i slot="default" class="el-icon-plus"></i>
                     <div slot="file" slot-scope="{file}">
                        <img
                            class="el-upload-list__item-thumbnail"
                            :src="file.url" alt=""
                        >
                        <span class="el-upload-list__item-actions">
                            <span
                            class="el-upload-list__item-preview"
                            @click="handlePictureCardPreview(file,index)"
                            >
                            <i class="el-icon-zoom-in"></i>
                            </span>
                            <!-- <span
                            v-if="!disabled"
                            class="el-upload-list__item-delete"
                            @click="handleDownload(file,index)"
                            >
                            <i class="el-icon-download"></i>
                            </span> -->
                            <span
                            v-if="!disabled"
                            class="el-upload-list__item-delete"
                            @click="handleRemove(file,index)"
                            >
                            <i class="el-icon-delete"></i>
                            </span>
                        </span>
                     </div>
                 </el-upload>
                   <el-upload  
                 v-if="item.messageType==3"
                 :action="uploadUrl()"
                 list-type="picture-card"
                 :on-success="(response,file,fileList)=>uploadSuccess(response,file,fileList,index)"
                 :file-list="item.content"
                 :before-upload="(fileList)=>beftoreUpload(fileList,item.messageType)"
                 :auto-upload="true">
                     <i slot="default" class="el-icon-plus"></i>
                
                     <div slot="file" slot-scope="{file}">
                        <video ref="video" controls controlslist="nodownload" autoplay class="el-upload-list__item-thumbnail"
                            preload="none"   poster="img" :src="file.url">
                        </video>
 
                        <span class="el-upload-list__item-actions">
                            <span
                            class="el-upload-list__item-preview"
                            @click="handlePictureCardPreview(file,index)"
                            >
                            <i class="el-icon-zoom-in"></i>
                            </span>
                            <!-- <span
                            v-if="!disabled"
                            class="el-upload-list__item-delete"
                            @click="handleDownload(file,index)"
                            >
                            <i class="el-icon-download"></i>
                            </span> -->
                            <span
                            v-if="!disabled"
                            class="el-upload-list__item-delete"
                            @click="handleRemove(file,index)"
                            >
                            <i class="el-icon-delete"></i>
                            </span>
                        </span> 
                     </div>
                 </el-upload>
                </el-col>
                <el-col :span="4">
                  <el-button style="margin-left:15px" v-if="index!=0" @click="delMessage(index)">删除</el-button>
                </el-col>

            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                <el-popover
                    placement="right"
                    width="300"
                    trigger="click">
                    <el-select v-model="currentMessageType" placeholder="请选择消息类型">
                        <el-option
                        v-for="item in messageType"
                        :key="item.type"
                        :label="item.label"
                        :value="item.type">
                        </el-option>
                      
                    </el-select>
                      <el-button type="primary" size="mini" @click="addMessage">新增</el-button>
                <el-button slot="reference" >新增一列</el-button>
                </el-popover>
            </el-form-item>
        </el-form>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogUrl" alt="" v-if="dialogMsgType==2">
            <video ref="video" controls controlslist="nodownload" autoplay class="el-upload-list__item-thumbnail"
                            preload="none"  poster="img" :src="dialogUrl" v-if="dialogMsgType==3">
            </video>
        </el-dialog>
    </div>
</template>
<script>
export default {
	name: 'autoReplyForm',
	props: [],
	data() {
        return {
            messageType:[
                {
                    type:1,
                    label:'文本',
                },
                {
                    type:2,
                    label:'图片',
                },
                {
                    type:3,
                    label:'视频'
                }
            ],
            dialogMsgType:0,
            dialogUrl: '',
            dialogVisible: false,
            disabled: false,
      
            file:[],
            currentMessageType:undefined
        }
    },
    created:function(){
      
 
       console.log(this.obj)
    },
    props:{
        title: {
			type: String,
			default: "自动回复文本录入",
		},
        obj: {
            type:Object,
            default:()=>{
                return {
                    isTrue:false,
                list:[
                    {
                        labelName:'文本',
                        content:'',
                        name:"1",
                        messageType:1,
                        order:1
                    },
                    {
                        labelName:'文本',
                        content:[],
                        name:"1",
                        messageType:2,
                        order:1
                    }
                ]
                }
            }
        },
        loading:{
            type:Boolean,
            default:false
        }
    },
    watch:{
      file:function(data){
          
          console.log(data)
      }
    },
    methods:{
        handleRemove(file,index) {
             
            let fileIndex = this.obj.list[index].content.findIndex(d=>d.uid==file.uid);
            this.obj.list[index].content.splice(fileIndex,1);
        },
        handlePictureCardPreview(file,index) {
            this.dialogUrl = file.url;
            this.dialogMsgType = this.obj.list[index].messageType;
            this.dialogVisible = true;
        },
        handleDownload(file,index) {
             
            this.dialogMsgType = this.obj.list[index].messageType;
         
        },
        submitForm(obj){
            console.log(this.$refs[obj])
            var $this= this;
           this.$refs[obj].validate((valid) => {
              var data = {...$this.obj};
            if (valid) {
                data.list = $this.analysisArray(data.list)
                $this.$emit('onSuccess',data);
            } else {
                $this.$message.error('提交失败!');
                return false;
            }
             });
        },
        analysisArray(list){
            var listContent = [];
            let order = undefined;
            list.forEach(element => {
                if(element.content instanceof Array){
                    element.content.forEach(item=>{
                            debugger
                            let obj = {...element};
                            obj.content=item.response.shortHref;
                            obj.id=item.id;
                            if(order!=undefined){
                                order+=1;
                                obj.order=order;
                            }else{
                                order=element.order;
                            }
                            listContent.push(obj)
                        })
                    }else{
                        if(order!=undefined){
                            order+=1;
                            element.order=order;
                        }   
                        listContent.push(element);
                    }
            });
            return listContent;
        },
        uploadSuccess(response, file, fileList,index){
            if(response.result){
                this.obj.list[index].content=fileList;
                this.$message.success("上传成功!");
            }else{
                this.$message.error("上传失败!");
            }
        },
        beftoreUpload(file,messageType){
            debugger
            if (messageType==2 && file.type.indexOf("image")==-1){
                this.$message.error("当前仅支持上传图片类型!");
                return false;
            }
            if(messageType==3 && file.type.indexOf("video")==-1){
                this.$message.error("当前仅支持上传视频类型!");
                return false;
            }
        },
        addMessage(){
            let obj = this.messageType.find(d=>d.type==this.currentMessageType)
            let order =Math.max(...this.obj.list.map(d=>d.order));
            this.obj.list.push({
                        labelName:obj.label,
                        content:(this.currentMessageType==2 || this.currentMessageType==3)?[]:"",
                        name:"",
                        messageType:this.currentMessageType,
                        order:order+1
            })
            this.currentMessageType=undefined
        },
        delMessage(index){
              
           this.obj.list.splice(index,1)
        },
        uploadUrl(){
            let url= this.axios.defaults.baseURL+'Upload'
            return url
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/manage/setting/autoReplyFrom.vue